import { BaseCommand } from './BaseCommand.js';
import { BuildManager } from '../build/BuildManager.js';
import { ConfigLoader } from '../config/ConfigLoader.js';

export class BuildCommand extends BaseCommand {
	async execute(options: any): Promise<void> {
		try {
			console.log('[Frame] Building for production...');

			const buildManager = new BuildManager(this.cwd);

			// Target precedence: CLI flag > frame.config build.target > 'static'.
			const frameConfig = await new ConfigLoader(this.cwd).load();
			const target = options.target || (frameConfig as any).build?.target || 'static';

			await buildManager.build({ mode: 'production', target });

			// Show build statistics
			const stats = await buildManager.getBuildStats(options.outDir || 'dist');
			console.log('\n[Frame] Build Statistics:');
			console.log(`  Total size: ${this.formatBytes(stats.totalSize)}`);
			console.log(`  Files: ${stats.fileCount}`);
			console.log(`  Output: ${stats.outputDir}`);

			// Show largest files
			console.log('\n[Frame] Largest files:');
			stats.files.slice(0, 5).forEach(file => {
				console.log(`  ${file.path} (${this.formatBytes(file.size)})`);
			});

		} catch (error) {
			console.error('[Frame] Build failed:', error);
			process.exit(1);
		}
	}

	private formatBytes(bytes: number): string {
		if (bytes === 0) return '0 B';
		const k = 1024;
		const sizes = ['B', 'KB', 'MB', 'GB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
	}
} 